import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { BOTTOM_SHEET_VIEWS } from 'src/store/bottom-sheet/bottomSheet.constants';
import { BUTTON_SIZES } from '../buttons/button/Button.constants';
import { IconQuaternaryOnLightButton } from '../icon-buttons/icon-quaternary-on-light-button/IconQuaternaryOnLightButton';
import { View } from 'react-native';
import { style } from './PhotoSlotButtonMobile.style';
import { PhotoSlotButtonProps } from './PhotoSlotButton.types';

export const PhotoSlotButtonMobile = observer(({ focusId, focusOrder, focusGroup }: PhotoSlotButtonProps) => {
  const { i18n, project, bottomSheet } = useStore();

  const onPress = async () => {
    if (bottomSheet.bottomSheetVisible) {
      bottomSheet.closeBottomSheet();
      return;
    }
    project.activeProject?.deselectAllThumbnailImages();
    bottomSheet.openBottomSheet({
      bottomSheetView: BOTTOM_SHEET_VIEWS.PhotoDrawer,
      showDragIndicator: false,
      contentViewStyle: { paddingHorizontal: 0 },
      showOpacityBackground: false,
      uploadButtonCallback: async () => {
        const id = await project.activeProject?.getDefaultProductIdByGroup(project.activeGroup);
        project?.addProductsV2({
          ids: project?.activeProject?.selectedThumbnails.map(t => t.originalImageId) ?? [],
          productConfigurationId:
            id || project?.activeGroup?.productConfigurationIdDefault || project?.productConfigurationId,
          groupCode: project?.activeGroup?.code || project?.groupCode,
          groupId: project?.activeGroup?.groupIdSDK,
        });
        bottomSheet.closeBottomSheet();
      },
    });
  };

  return (
    <IconQuaternaryOnLightButton
      accessible={true}
      accessibilityRole="button"
      // Dynamic label: announce badge state so screen readers know new photos are available
      accessibilityLabel={
        project.showNotificationPhotoDrawer ? i18n.t('header:photo-notification') : i18n.t('header:photo')
      }
      onPress={onPress}
      focusId={focusId}
      focusOrder={focusOrder}
      focusGroup={focusGroup}
      size={BUTTON_SIZES.SMALL}
      iconName={ICON_NAMES.PhotoAlbum}
      badgeRenderer={project.showNotificationPhotoDrawer && <View style={style.iconBadge} accessible={false} />}
    />
  );
});
